export const getPreviewUrl = (file, callback) => {
  const fr = new FileReader();
  fr.readAsDataURL(file);
  fr.onload = (e) => {
    callback(e.target.result);
  };
};
